// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f1c55d53","455":"669b95d5","977":"23b16c57"}[chunkId] + ".chunk.js";
};